import * as React from 'react'
import AppBar from 'material-ui/AppBar'
import {Step, StepLabel, Stepper} from 'material-ui/Stepper'
import FlatButton from 'material-ui/FlatButton'
import RaisedButton from 'material-ui/RaisedButton'
import {url} from '../../App/AuthenticatedRoute'
import {OrderCreateState} from './OrderCreateState'
import {OrderCreateAction} from './OrderCreateActions'
import {Step1View} from './Step1/Step1View'
import {Step2View} from './Step2/Step2View'
import {Step3View} from './Step3/Step3View'
import {Step4View} from './Step4/Step4'
import {Step5View} from './Step5/Step5View'
import {MenuAndUpButton} from '../../View/MenuAndUpButton'
import AlertError from 'material-ui/svg-icons/alert/error'
import ContentSend from 'material-ui/svg-icons/content/send'
import NavigationCheck from 'material-ui/svg-icons/navigation/check'
import CircularProgress from 'material-ui/CircularProgress'
import injectSheet from 'react-jss'

interface Props {
    state: OrderCreateState
    dispatch: (action: OrderCreateAction) => void
}

const styles = {
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    orderCreateWrapper: {
        overflowY: 'scroll',
        flex: '1'
    }
}

export const OrderCreateView =
    injectSheet<Props>(styles)(
        ({classes, state, dispatch}) => (
            <div className={classes.root}>
                <div className="navigation">
                    <AppBar
                        title="Neuer Auftrag"
                        className="navigation__bar"
                        iconElementLeft={
                            <MenuAndUpButton
                                onMenuButtonClicked={() => dispatch({
                                    type: 'MenuButtonClicked',
                                })}
                                upUrl={url({type: 'OrderOverview'})}
                            />}
                    />
                </div>
                <div className={classes.orderCreateWrapper}>
                    <div
                        className="stepper"
                        style={{justifyContent: 'center', display: 'flex'}}
                    >
                        <Stepper
                            style={{minWidth: '60%'}}
                            activeStep={state.currentTab.index - 1}
                        >
                            <Step>
                                <StepLabel>Auftrag definieren</StepLabel>
                            </Step>
                            <Step>
                                <StepLabel>Produkte hinzufügen</StepLabel>
                            </Step>
                            <Step>
                                <StepLabel>
                                    Rechnungs-/Lieferinformationen
                                </StepLabel>
                            </Step>
                            <Step>
                                <StepLabel>Übersicht</StepLabel>
                            </Step>
                        </Stepper>
                    </div>
                    <Content
                        state={state}
                        dispatch={dispatch}
                    />
                    <div className="stepper-buttonset">
                        <div>
                            {
                                state.currentTab.index > 1 &&
                                state.currentTab.index < 5 &&
                                <FlatButton
                                    label="Zurück"
                                    onTouchTap={() => dispatch({
                                        type: 'PreviousStep',
                                    })}
                                    style={{marginRight: '20px'}}
                                />}
                            <RaisedButton
                                label={
                                    state.currentTab.type === 'Step3Tab' ?
                                        'Zur Übersicht' :
                                        state.currentTab.type === 'Step4Tab' ?
                                            'Abschicken' :
                                            state.currentTab.type === 'Step5Tab' ?
                                                'Fertig' :
                                                'Weiter'}
                                primary={true}
                                onTouchTap={() => dispatch({
                                    type: 'NextStep',
                                })}
                                disabled={
                                    state.createdOrder.type === 'Loading' ||
                                    state.createdOrder.type === 'Success'
                                }
                                icon={
                                    state.currentTab.type === 'Step4Tab' && (() => {
                                        switch (state.createdOrder.type) {
                                            case 'NotAsked':
                                                return <ContentSend/>
                                            case 'Loading':
                                                return <CircularProgress size={24}/>
                                            case 'Success':
                                                return <NavigationCheck/>
                                            case 'Failure':
                                                return <AlertError/>
                                        }
                                    })()
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    )

function Content({state, dispatch}: {
    state: OrderCreateState,
    dispatch: (action: OrderCreateAction) => void,
}) {
    switch (state.currentTab.type) {
        case 'Step1Tab':
            return (
                <Step1View
                    state={state.currentTab.state}
                    dispatch={
                        subAction => dispatch({
                            type: 'Step1Action',
                            subAction,
                        })}
                />)
        case 'Step2Tab':
            return (
                <Step2View
                    state={state.currentTab.state}
                    dispatch={
                        subAction => dispatch({
                            type: 'Step2Action',
                            subAction,
                        })}
                />)
        case 'Step3Tab':
            return (
                <Step3View
                    state={state.currentTab.state}
                    dispatch={
                        subAction => dispatch({
                            type: 'Step3Action',
                            subAction,
                        })}
                />)
        case 'Step4Tab':
            return (
                <Step4View
                    step1={state.currentTab.step1}
                    step2={state.currentTab.step2}
                />)
        case 'Step5Tab':
            return <Step5View orderNumber={state.currentTab.orderNumber}/>
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/OrderCreate/OrderCreateView.tsx